"use client"

import { HttpTypes } from "@medusajs/types"
import type { SearchResultsBlock, ViewMode } from "../../templates/search-template"
import SearchProductCard from "../search-product-card"
import SearchProductListItem from "../search-product-list-item"

type ProductGridProps = {
  hits: any[]
  viewMode: ViewMode
  countryCode: string
  customer?: HttpTypes.StoreCustomer | null
  /** Only the global /search page sets this (see SearchResults). */
  searchResultsClickSurface?: "search_grid" | "search_list"
  /** Which /search block the hits belong to, reported with result clicks. */
  searchResultsBlock?: SearchResultsBlock
  /** Eager-load images for the first N grid cards (LCP). */
  priorityCount?: number
}

export default function ProductGrid({
  hits,
  viewMode,
  countryCode,
  customer,
  searchResultsClickSurface,
  searchResultsBlock,
  priorityCount = 0,
}: ProductGridProps) {
  if (viewMode === "grid") {
    return (
      <div className="grid grid-cols-2 lg:grid-cols-3 gap-6">
        {hits.map((product: any, index: number) => (
          <SearchProductCard
            key={product.id || product.handle || `product-${index}`}
            product={product}
            countryCode={countryCode}
            customer={customer}
            searchResultsClickSurface={searchResultsClickSurface}
            searchResultsBlock={searchResultsBlock}
            priority={index < priorityCount}
          />
        ))}
      </div>
    )
  }

  return (
    <div className="space-y-4">
      {hits.map((product: any, index: number) => (
        <SearchProductListItem
          key={product.id || product.handle || `product-${index}`}
          product={product}
          countryCode={countryCode}
          customer={customer}
          searchResultsClickSurface={searchResultsClickSurface}
          searchResultsBlock={searchResultsBlock}
        />
      ))}
    </div>
  )
}
